import { api } from './client'

const expenseService = {
  getExpenses: async ({ matterId, startDate, endDate, limit = 100, offset = 0 } = {}) => {
    const params = { entry_type: 'expense', limit, offset }
    if (matterId) params.matterId = matterId
    if (startDate) params.after = startDate
    if (endDate) params.before = endDate
    const resp = await api.get('/billing-entries', params)
    return { expenses: resp.data, total: resp.meta.total }
  },

  saveExpense: async (expense) => {
    const resp = await api.post('/billing-entries', {
      ...expense,
      entryType: 'expense',
    })
    return resp.data
  },

  getExpenseCodes: async () => {
    const resp = await api.get('/billing-entries/codes', { entry_type: 'expense' })
    return resp.data
  },
}

export default expenseService
